export default __webpack_public_path__ + "static/media/icon.85e58198.png";